const APP_PREFIX = "/app";

export function safeNextPath(value: string | null | undefined): string {
  if (!value) {
    return APP_PREFIX;
  }

  const raw = value.trim();
  if (!raw.startsWith("/") || raw.startsWith("//")) {
    return APP_PREFIX;
  }

  const hashless = raw.split("#")[0] ?? "";
  const queryIndex = hashless.indexOf("?");
  const pathname = queryIndex === -1 ? hashless : hashless.slice(0, queryIndex);
  const search = queryIndex === -1 ? "" : hashless.slice(queryIndex);

  let decoded = pathname;
  try {
    decoded = decodeURIComponent(pathname);
  } catch {
    return APP_PREFIX;
  }

  if (
    !decoded.startsWith(APP_PREFIX) ||
    (decoded !== APP_PREFIX && !decoded.startsWith(`${APP_PREFIX}/`)) ||
    decoded.includes("\\") ||
    decoded.includes("//") ||
    decoded.includes("..")
  ) {
    return APP_PREFIX;
  }

  return `${decoded}${search}`;
}

export function safeAuthNext(value: string | null | undefined): string {
  const invite = safeInvitePath(value);
  if (invite) {
    return invite;
  }
  return safeNextPath(value);
}

function safeInvitePath(value: string | null | undefined): string | null {
  if (!value) {
    return null;
  }
  const raw = value.trim().split("#")[0] ?? "";
  if (!raw.startsWith("/") || raw.startsWith("//") || raw.includes("\\") || raw.includes("..")) {
    return null;
  }
  const pathname = raw.split("?")[0] ?? "";
  if (pathname === "/invite/resume") {
    return pathname;
  }
  if (!pathname.startsWith("/invite/")) {
    return null;
  }
  const token = pathname.slice("/invite/".length);
  if (!/^[A-Za-z0-9_-]{20,200}$/.test(token) || token.includes("/")) {
    return null;
  }
  return pathname;
}
